/* tslint:disable */
/* eslint-disable */
/**
 * Apideck
 * The Apideck OpenAPI Spec: SDK Optimized
 *
 * The version of the OpenAPI document: 10.13.0
 * Contact: support@apideck.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
/**
 *
 * @export
 * @interface CreateCallbackStateResponseData
 */
export interface CreateCallbackStateResponseData {
  /**
   * Callback state
   * @type {string}
   * @memberof CreateCallbackStateResponseData
   */
  readonly state?: string
}

export function CreateCallbackStateResponseDataFromJSON(
  json: any
): CreateCallbackStateResponseData {
  return CreateCallbackStateResponseDataFromJSONTyped(json, false)
}

export function CreateCallbackStateResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateCallbackStateResponseData {
  if (json === undefined || json === null) {
    return json
  }
  return {
    state: !exists(json, 'state') ? undefined : json['state']
  }
}

export function CreateCallbackStateResponseDataToJSON(
  value?: CreateCallbackStateResponseData | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {}
}
